import { render, staticRenderFns } from "./CustomMarkingHeader.vue?vue&type=template&id=7e65ceff&scoped=true"
import script from "./CustomMarkingHeader.vue?vue&type=script&lang=js"
export * from "./CustomMarkingHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomMarkingHeader.vue?vue&type=style&index=0&id=7e65ceff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../test-qa.dotag.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65ceff",
  null
  
)

export default component.exports